import { isNil, pick, pickBy } from 'lodash';

const PIPELINE_CONFIGURATION_FIELDS = ['filter', 'transform', 'eventSplit'];

export default function selectPipelineConfiguration(pipeline) {
  return pickBy(pick(pipeline, PIPELINE_CONFIGURATION_FIELDS), value => !isNil(value));
}
